/**
 * Application Constants
 */

export const ROUTE_PATHS = {
  HOME: '/',
  LOGIN: '/login',
  LOGOUT: '/logout',
  BALANCE: '/balance',
  CONFIRMATION: '/confirmation',
  TRANSACTION_RESULT: '/transaction-result',
  ERROR: '/error',
} as const;

export const ERROR_MESSAGES = {
  GENERIC: 'An unexpected error occurred. Please try again later.',
  NETWORK: 'Unable to connect to the server. Please check your internet connection.',
  UNAUTHORIZED: 'Your session has expired. Please log in again.',
  INVALID_CREDENTIALS: 'Invalid Policy Number or Reference Number.',
  VALIDATION: 'Please check your input and try again.',
  PAYMENT_FAILED: 'Payment processing failed. Please try again.',
} as const;

export const SUCCESS_MESSAGES = {
  LOGIN: 'Successfully logged in',
  PAYMENT_PREPARED: 'Payment prepared successfully',
  PAYMENT_SUCCESS: 'Payment processed successfully',
} as const;

export const LOADING_MESSAGES = {
  LOGGING_IN: 'Logging in...',
  LOADING_BALANCE: 'Loading your balance information...',
  PREPARING_PAYMENT: 'Preparing your payment...',
  PROCESSING_PAYMENT: 'Processing your payment...',
  GENERATING_STATEMENT: 'Generating statement...',
} as const;

export const CONTACT_INFO = {
  PHONE: '1-800-XXX-XXXX',
  EMAIL: 'support@rsui.com',
  HOURS: 'Monday - Friday, 8:00 AM - 5:00 PM EST',
} as const;
